'use strict';

angular.module('mean.projects').factory('projectCompleteService', ['$filter', 'toaster', 'ProjectTasks', 'Projects', 'ProjectBids', 'ProjectHours', 'ProjectEquipments', 'ProjectMaterials', 'Bids', 'Options', 'Extras', 'DocumentSevice', 'ngDialog',
    function($filter, toaster, ProjectTasks, Projects, ProjectBids, ProjectHours, ProjectEquipments, ProjectMaterials, Bids, Options, Extras, DocumentSevice, ngDialog) {

        console.log('projectCompleteService loading up');
        var setCompleteProjectHours = function(value, project_id) {
            ProjectHours.query({
                'type': 'SetCompleteForProject',
                'project_id': project_id,
                'complete': value }, function(hours) {

                if(hours.length === 1) {
                    toaster.pop('success', 'Database updated', hours[0].message);
                } else {
                    toaster.pop('error', 'Database update error', 'Something went wrong');
                }
            });
        };

        var setCompleteProjectTasks = function(value, project_id) {
            ProjectTasks.query({
                'type': 'SetCompleteForProject',
                'project_id': project_id,
                'complete': value }, function(tasks) {

                if(tasks.length === 1) {
                    toaster.pop('success', 'Database updated', tasks[0].message);
                } else {
                    toaster.pop('error', 'Database update error', 'Something went wrong');
                }
            });
        };

        var setCompleteProjectBids = function(value, project_id) {
            ProjectBids.query({
                'type': 'SetCompleteForProject',
                'project_id': project_id,
                'complete': value }, function(bids) {

                if(bids.length === 1) {
                    toaster.pop('success', 'Database updated', bids[0].message);
                } else {
                    toaster.pop('error', 'Database update error', 'Something went wrong');
                }
            });
        };

        var setCompleteProjectMaterials = function(value, project_id) {
            ProjectMaterials.query({
                'type': 'SetCompleteForProject',
                'project_id': project_id,
                'complete': value }, function(materials) {

                if(materials.length === 1) {
                    toaster.pop('success', 'Database updated', materials[0].message);
                } else {
                    toaster.pop('error', 'Database update error', 'Something went wrong');
                }
            });
        };

        var setCompleteProjectEquipment = function(value, project_id) {
            ProjectEquipments.query({
                'type': 'SetCompleteForProject',
                'project_id': project_id,
                'complete': value }, function(equipment) {

                if(equipment.length === 1) {
                    toaster.pop('success', 'Database updated', equipment[0].message);
                } else {
                    toaster.pop('error', 'Database update error', 'Something went wrong');
                }
            });
        };

        var setCompleteProject = function(value, project_id) {
            Projects.query({
                '_id': project_id }, function(projects) {

                if(projects.length === 1) {
                    projects[0].complete = value;
                    projects[0].$update(function(success) {
                        toaster.pop('success', 'Database updated', 'Project Closed');
                    }, function(error) {
                        toaster.pop('error', 'Database update error', error);
                    })
                } else {
                    toaster.pop('error', 'Projects Database', 'Did not get the expected project from the database.');
                }
            });
        };

        var setCompleteOptions = function(value, project_id) {
            Options.query({
                'type': 'SetCompleteForProject',
                'project_id': project_id,
                'complete': value }, function(options) {

                if(options.length === 1) {
                    toaster.pop('success', 'Database updated', options[0].message);
                } else {
                    toaster.pop('error', 'Database update error', 'Something went wrong');
                }
            });
        };

        var setCompleteExtras = function(value, project_id) {
            Extras.query({
                'type': 'SetCompleteForProject',
                'project_id': project_id,
                'complete': value }, function(extras) {

                if(extras.length === 1) {
                    toaster.pop('success', 'Database updated', extras[0].message);
                } else {
                    toaster.pop('error', 'Database update error', 'Something went wrong');
                }
            });
        };

        var reStoreStructure = function(value, project_id) {
            DocumentSevice.query({
                'type': 'reopenProject',
                'projectId': project_id,
                'isDeleted': value }, function(response) {
                    toaster.pop('success', 'Database updated', 'Document resore successfully');
            });
        };

        var setComplete = function(value, project_id) {
            Bids.query({'project_id': project_id}, function(bids) {
                if(bids.length === 1) {
                    if(value) {
                        bids[0].complete = true;
                        bids[0].bid_status = 'complete';
                    } else {
                        bids[0].complete = false;
                        bids[0].bid_status = 'project';
                    }
                    bids[0].$update(function(success) {
                        setCompleteProjectHours(value, project_id);
                        setCompleteProjectTasks(value, project_id);
                        setCompleteProjectBids(value, project_id);
                        setCompleteProjectMaterials(value, project_id);
                        setCompleteProjectEquipment(value, project_id);
                        setCompleteOptions(value, project_id);
                        setCompleteExtras(value, project_id);
                        setCompleteProject(value, project_id);
                        reStoreStructure(value, project_id);
                    }, function(error) {
                        toaster.pop('error', 'Database update error', error);
                    });
                } else if(bids.length === 0) {
                    Projects.query({'_id': project_id}, function(projects) {
                        if(projects.length !== 1) {
                            toaster.pop('error', 'Project Not Found', 'Contact Admin.');
                            return;
                        }

                        Bids.query({'project_name': projects[0].name}, function(bids) {
                            if(bids.length === 0) {
                                toaster.pop('error', 'Bid Search Error',
                                    'Could not find a bid with the current project name');
                                setCompleteProjectHours(value, project_id);
                                setCompleteProjectTasks(value, project_id);
                                setCompleteProjectBids(value, project_id);
                                setCompleteProjectMaterials(value, project_id);
                                setCompleteProjectEquipment(value, project_id);
                                setCompleteOptions(value, project_id);
                                setCompleteExtras(value, project_id);
                                setCompleteProject(value, project_id);
                                return;
                            }

                            var retObj = {
                                available_bids: bids
                            }
                            ngDialog.openConfirm({
                                template: 'projects/views/project/project-bid-association.html',
                                data: retObj,
                                className: 'ngdialog-theme-default'
                            }).then(function (value) {
                                retObj.selected_bid_for_association.complete = true;
                                retObj.selected_bid_for_association.bid_status = 'complete';
                                retObj.selected_bid_for_association.project_id = project_id;
                                retObj.selected_bid_for_association.$update(function(success) {
                                    setCompleteProjectHours(value, project_id);
                                    setCompleteProjectTasks(value, project_id);
                                    setCompleteProjectBids(value, project_id);
                                    setCompleteProjectMaterials(value, project_id);
                                    setCompleteProjectEquipment(value, project_id);
                                    setCompleteOptions(value, project_id);
                                    setCompleteExtras(value, project_id);
                                    setCompleteProject(value, project_id);
                                }, function(error) {
                                    toaster.pop('error', 'Bid/Project Association Error',
                                        error)
                                })
                            }, function (value) {
                                //Do something 
                                console.log('in the do something section');
                            });
                        });
                    });
                }
            });
        };

        return {
            setComplete: setComplete
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/project-complete-service.js